import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import ViewType from "~/@types/viewType";

type ForecastWeeklyMetric = "Sales" | "Ships";

interface ForecastState {
	highlightEditableCells: boolean;
	itemsViewType: ViewType;
	lastOpenedSessionIds: string[];
	locationsViewType: ViewType;
	openSessionId: string | null;
	selectedForecastId: string | null;
	summaryPanelOpen: boolean;
	weeklyMetric: ForecastWeeklyMetric;
}

const initialState: ForecastState = {
	highlightEditableCells: true,
	itemsViewType: "card",
	lastOpenedSessionIds: [],
	locationsViewType: "card",
	openSessionId: null,
	selectedForecastId: null,
	summaryPanelOpen: true,
	weeklyMetric: "Ships"
};

const MAX_RECENT_SESSIONS = 5;

export const forecastSlice = createSlice({
	initialState,
	name: "forecast",
	reducers: {
		clearOpenSession: (state) => {
			state.openSessionId = null;
		},
		clearSelectedForecast: (state) => {
			state.selectedForecastId = null;
		},
		setHighlightEditableCells: (state, action: PayloadAction<boolean>) => {
			state.highlightEditableCells = action.payload;
		},
		setItemsViewType: (state, action: PayloadAction<ViewType>) => {
			state.itemsViewType = action.payload;
		},
		setLocationsViewType: (state, action: PayloadAction<ViewType>) => {
			state.locationsViewType = action.payload;
		},
		setOpenSession: (state, action: PayloadAction<string>) => {
			state.openSessionId = action.payload;
			state.lastOpenedSessionIds = [
				action.payload,
				...state.lastOpenedSessionIds.filter((sessionId) => sessionId !== action.payload)
			].slice(0, MAX_RECENT_SESSIONS);
		},
		setSelectedForecast: (state, action: PayloadAction<string>) => {
			state.selectedForecastId = action.payload;
		},
		setSummaryPanelOpen: (state, action: PayloadAction<boolean>) => {
			state.summaryPanelOpen = action.payload;
		},
		setWeeklyMetric: (state, action: PayloadAction<ForecastWeeklyMetric>) => {
			state.weeklyMetric = action.payload;
		}
	}
});

export const {
	clearOpenSession,
	clearSelectedForecast,
	setHighlightEditableCells,
	setItemsViewType,
	setLocationsViewType,
	setOpenSession,
	setSelectedForecast,
	setSummaryPanelOpen,
	setWeeklyMetric
} = forecastSlice.actions;

export default forecastSlice.reducer;
